<mat-toolbar color="primary">
  <h1 class="mat-title">{{title}}</h1>
</mat-toolbar>
<form [formGroup]="relationForm" (submit)="onSend()">
  <div class="relation hide-hint ds-uf-column">
    <mat-form-field>
      <mat-label>Bedrijfsnaam</mat-label>
      <input matInput type="text" formControlName="companyname"/>
    </mat-form-field>
    <mat-form-field>
      <mat-label>BTW Nummer</mat-label>
      <input matInput type="text" formControlName="vatnumber"/>
    </mat-form-field>
    <div class="relation-name">
      <mat-form-field class="first-name">
        <mat-label>Voornaam</mat-label>
        <input matInput type="text" formControlName="firstname"/>
      </mat-form-field>
      <mat-form-field class="infix">
        <mat-label>Tussenvoegsel</mat-label>
        <input matInput type="text" formControlName="infix"/>
      </mat-form-field>
      <mat-form-field class="family-name">
        <mat-label>Achternaam</mat-label>
        <input matInput type="text" formControlName="familyname"/>
      </mat-form-field>
    </div>
    @if (communicationType) {
      <div class="communications" formArrayName="communications">
        <mat-form-field [formGroupName]="0">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="value"/>
        </mat-form-field>
      </div>
    }
    @if (addressType) {
      <div formArrayName="addresses">
        <div class="addresses" [formGroupName]="0">
          <div class="address-line">
            <mat-form-field>
              <mat-label>Postcode</mat-label>
              <input matInput type="text" formControlName="zip"/>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Nummer</mat-label>
              <input matInput type="text" formControlName="housenumber"/>
            </mat-form-field>
          </div>
          <div class="address-line">
            <mat-form-field>
              <mat-label>Straat</mat-label>
              <input matInput type="text" formControlName="street"/>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Plaats</mat-label>
              <input matInput type="text" formControlName="city"/>
            </mat-form-field>
          </div>
          <mat-form-field>
            <mat-label>Land</mat-label>
            <mat-select placeholder="Land" formControlName="isoCountryId">
              @for (country of countries; track country.id) {
                <mat-option [value]="country.id">
                  {{country.commonName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }

    <div class="action-buttons">
      <button mat-button mat-raised-button type="button" (click)="onClose()">Annuleren</button>
      <button mat-button mat-raised-button color="primary" type="submit" [disabled]="!relationForm.dirty || !relationForm.valid">Aanmaken</button>
    </div>
  </div>
</form>

